const streamToText = async (readableStream: ReadableStream): Promise<string> => {
  const reader = readableStream.getReader()
  const decoder = new TextDecoder('utf-8')
  let text = ''
  // eslint-disable-next-line no-constant-condition
  while (true) {
    // eslint-disable-next-line no-await-in-loop
    const { done, value } = await reader.read()
    if (done) {
      break
    }
    text += decoder.decode(value)
  }
  return text
}

const textToJson = (text: string): Record<string, unknown> | unknown[] | string | number | boolean | null => {
  try {
    return JSON.parse(text)
  } catch (error) {
    throw new Error(`Failed to parse text as JSON: ${(error as Error).message}`)
  }
}

export const processStream = async (
  readableStream: ReadableStream
): Promise<Record<string, unknown> | unknown[] | string | number | boolean | null> => {
  try {
    const text = await streamToText(readableStream)
    return textToJson(text)
  } catch (error) {
    return error instanceof Error ? error.message : String(error)
  }
}

export const parseError = async (
  error: Record<string, unknown> | Error | string
): Promise<Record<string, unknown> | unknown[] | string | number | boolean | null> => {
  if (!error || typeof error !== 'object' || !('context' in error))
    return error as Record<string, unknown> | string
  const errorObj = error as { context?: { body?: ReadableStream } }
  const { body } = errorObj.context || {}
  if (!body) {
    return error as Record<string, unknown>
  }
  const parsedError = await processStream(body)
  if (parsedError && typeof parsedError === 'object' && parsedError !== null && 'error' in parsedError) {
    return (
      (parsedError as { error?: Record<string, unknown> | unknown[] | string | number | boolean | null })
        .error ?? parsedError
    )
  }
  return error as Record<string, unknown>
}
